export default __webpack_public_path__ + "static/media/congrats.590361ab.svg";